var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApplicationWrapper, InformationCheckWrapper, Language, navigate, Route, Routes } from '@teliaee/crm-components';
import icons from '@teliaee/icons/sprite.svg';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import TagManager from 'react-gtm-module';
import { Main, MainContent, RouterProvider, Separator, Spinner } from 'telia-front-react';
import { enGB, et, ru } from 'telia-front-react/locale';
import { NotFound, ValidationFallback } from './auth/ValidationFallback';
import Config from './Config';
import Footer from './footer/FooterContainer';
import HeaderContainer from './header/AppHeader';
import AccountPage from './pages/AccountPage';
import FrontPage from './pages/FrontPage';
import { InformationUpdatePage } from './pages/InformationUpdatePage';
import { InformationUpdatePageOld } from './pages/InformationUpdatePageOld';
import RegistrationPage from './pages/RegistrationPage';
import RootStore, { RootStoreContext } from './stores/RootStore';
import API from './util/ApiUtil';
import { arrayContentsDiffer } from './util/DiffUtil';
TagManager.initialize({ gtmId: 'GTM-MQQKQ7' });
let App = class App extends React.Component {
    constructor(initialStateHolder) {
        super(initialStateHolder);
        Object.defineProperty(this, "validationErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cookieConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getLocale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                switch (this.rootStore.translateStore.currentLanguage) {
                    case Language.EN:
                        return enGB;
                    case Language.RU:
                        return ru;
                    default:
                        return et;
                }
            }
        });
        makeObservable(this);
        if (initialStateHolder.initialState == null) {
            const emptyInitialState = {};
            initialStateHolder = { initialState: emptyInitialState };
        }
        this.rootStore = new RootStore(initialStateHolder.initialState);
        this.cookieConsentStore = this.rootStore.cookieConsentStore;
        API.initializeInterceptors(this.rootStore.ssoStore);
    }
    onLocationChange(errors) {
        if (arrayContentsDiffer(this.validationErrors, errors)) {
            this.validationErrors = errors;
        }
    }
    render() {
        var _a, _b, _c;
        const { ssoStore, translateStore } = this.rootStore;
        if (!translateStore.diilGlobalTranslations || !ssoStore.ssoLoaded || ssoStore.loggingOut) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Separator, { color: "invisible" }),
                React.createElement(Spinner, null)));
        }
        return (React.createElement(ApplicationWrapper, { environment: Config.environment, brand: "DIIL", icons: icons, themeProvider: {
                brand: 'diil',
                theme: 'light',
                locale: this.getLocale()
            }, sso: {
                isDealer: !!ssoStore.dealer,
                isLoggedIn: ssoStore.loggedIn,
                isLoggedInWithHardAuth: ssoStore.loggedInWithHardAuth,
                loggedInPerson: {
                    registrationNumber: (_a = ssoStore.person) === null || _a === void 0 ? void 0 : _a.personalCode,
                    registrationNumberCountryCode: (_b = ssoStore.person) === null || _b === void 0 ? void 0 : _b.personalCodeCountryCode
                },
                representative: { ...ssoStore.customer, type: (_c = ssoStore.customer) === null || _c === void 0 ? void 0 : _c.type }
            } },
            React.createElement(RootStoreContext.Provider, { value: this.rootStore },
                React.createElement(RouterProvider, { navigate: (event) => navigate(event.currentTarget.pathname) },
                    React.createElement(Main, { consentEnabled: this.cookieConsentStore.isCookiebotEnabled, consent: { ...this.cookieConsentStore.cookieConsents } },
                        React.createElement(HeaderContainer, null),
                        React.createElement(MainContent, null,
                            React.createElement(InformationCheckWrapper, { redirectToInformationUpdate: () => navigate('/konto/andmete-uuendamine') },
                                React.createElement(Routes, { onChange: (_, errors) => this.onLocationChange(errors), fallbackElement: React.createElement(ValidationFallback, { errors: this.validationErrors }), restrictions: {
                                        customerType: 'B2C',
                                        requiresAuth: true,
                                        requiresRepresentative: true,
                                        customerContract: { requiresContract: !ssoStore.isDealer, redirectLink: '/konto/registreerimine' }
                                    } },
                                    React.createElement(Route, { path: "/", title: translateStore.translate('frontPage.documentTitle'), element: React.createElement(FrontPage, null) }),
                                    React.createElement(Route, { path: "/konto/registreerimine", title: translateStore.translate('registration.documentTitle'), element: React.createElement(RegistrationPage, null), restrictions: { requiresHardAuth: true } }),
                                    React.createElement(Route, { path: "/konto", title: translateStore.translate('accountPage.documentTitle'), element: React.createElement(AccountPage, null), restrictions: {
                                            requiresHardAuth: true,
                                            requiresBrandSpecificOrLegalMandate: true
                                        } }),
                                    React.createElement(Route, { path: "/konto/andmete-uuendamine", element: React.createElement(InformationUpdatePageOld, null), restrictions: { receivedMandates: { requiresMandates: ['LEGAL'] } } }),
                                    React.createElement(Route, { path: "/konto/andmete-uuendamine/uus", element: React.createElement(InformationUpdatePage, null), restrictions: { receivedMandates: { requiresMandates: ['LEGAL'] } } }),
                                    React.createElement(Route, { path: "*", element: React.createElement(NotFound, null), restrictions: null })))),
                        React.createElement(Footer, null))))));
    }
};
__decorate([
    observable
], App.prototype, "validationErrors", void 0);
__decorate([
    action.bound
], App.prototype, "onLocationChange", null);
App = __decorate([
    observer
], App);
export { App };
export default App;
